<template>
  <div ref="salepage" style="position: relative; padding: 0px 0 30px">
    <v-premium-plan-popup
      :showAll="false"
      marginTop="65"
      v-if="$store.getters.getPackage != 'premium'"
      style="border-radius: 5px;"
      text="Upgrade to Premium, starting at 500 baht / month to create your sales page as a one-page website, that can bring your website’s link to different social medias. Reach more potential customers to your products and increase the chances of closing the deal. Upgrade now"
    ></v-premium-plan-popup>
    <form v-if="!setload">
      <v-container>
        <div style="float: right;">
          <toggle-button
            v-if="this.isEdit"
            class="mt-2"
            :value="salePageIsActive"
            :sync="true"
            :color="$vuetify.theme.success"
            @change="toggleActiveSalePage"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />
        </div>
        <h2>
          Sale Page
          <v-modal-help style="font-size:15px">
            <div slot="body">
              <img class="responsive-img" src="/static/img/assets/salepagehelp.png" />
              <div style="padding: 10px 50px;">
                <p class="strong">{{ $t('Create sale page') }}:</p>
                <ol type="1" style="margin-bottom: 15px">
                  <li style="list-style: decimal">
                    {{ $t('Add products and services (Settings > Shop Service > Add Products)') }}
                  </li>
                  <li style="list-style: decimal">
                    {{
                      $t(
                        'Decorate the shop and add details (Settings > One-stop shop service > Sale page)'
                      )
                    }}
                  </li>
                  <li style="list-style: decimal">
                    {{ $t('Add a pixel to penetrate customer behavior.') }}
                  </li>
                  <li style="list-style: decimal">
                    {{
                      $t(
                        'Just this, the shop can copy the Sale Page link and send it to customers to continue shopping on all platforms.'
                      )
                    }}
                  </li>
                </ol>
                <p>
                  {{ $t('Read more about how to use it.') }}่
                  <a href="https://tinyurl.com/y8kv4k9h" target="_blank">{{ $t('Click') }}</a>
                </p>
              </div>
            </div>
          </v-modal-help>
        </h2>
        <v-layout wrap row>
          <v-flex
            xs12
            sm12
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('shopName') }"
          >
            <label>{{ $t('Shop name') }}</label>
            <input
              :data-vv-as="$t('Shop name')"
              v-model="shopName"
              v-validate="'required'"
              class="form-control"
              type="text"
              name="shopName"
            />
            <span class="text-error" v-if="errors.has('shopName')">{{
              errors.first('shopName')
            }}</span>
          </v-flex>
          <v-flex v-if="selectedBot" xs12 sm12 class="form-control pa-1">
            <label>{{ $t('Shop link') }}</label>
            <div style="display: flex;">
              <input
                :disabled="true"
                :data-vv-as="$t('Shop link')"
                :value="`https://shopv2.zwiz.app/salepage/${selectedBot.pageid}`"
                name="shopLink"
                class="form-control"
                type="text"
              />
              <v-tooltip v-model="showCopy" bottom color="success">
                <template v-slot:activator="{}">
                  <v-btn
                    flat
                    fab
                    small
                    class="ma-0"
                    color="primary"
                    v-clipboard:copy="`https://shopv2.zwiz.app/salepage/${selectedBot.pageid}`"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onCopyError"
                  >
                    <v-icon>file_copy</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('Copied') }}</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
        <div class="hr" style="margin-top: 20px; "></div>
        <div class="text-xs-center" style="margin: -13px;margin-bottom: 10px;">
          <a
            class="text btn-advanced"
            href="javascript:void(0);"
            @click="onShowAdvance"
            style="position:relative"
          >
            <i
              class="fa"
              :class="{ 'fa-angle-down': !showAdvanced, 'fa-angle-up': showAdvanced }"
            ></i>
          </a>
        </div>
        <transition name="fade">
          <div v-show="showAdvanced" style="position: relative">
            <v-premium-plan-popup2
              v-if="!getPackageConfig().salepageAnalytics"
              type="advanced"
              text="Upgrade to Advanced, starting at 990 baht / month to store Pixel on many platforms, which track customers’ behavior that access your sell page. This can be used for remarketing or for the further Advertising optimization Upgrade now"
            ></v-premium-plan-popup2>
            <v-layout wrap row>
              <v-flex
                xs12
                sm12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('fbPixel') }"
              >
                <label
                  >{{ $t('Facebook Pixel') }} ({{
                    $t('Beta a temporary trial of the system')
                  }})</label
                >
                <div style="display: flex;">
                  <input
                    :disabled="!getPackageConfig().salepageAnalytics"
                    placeholder="FB Pixel ID"
                    :data-vv-as="$t('Facebook Pixel')"
                    v-model="fbPixel"
                    v-validate="''"
                    name="fbPixel"
                    class="form-control"
                    type="text"
                  />
                </div>
                <span class="text-error" v-if="errors.has('fbPixel')">{{
                  errors.first('fbPixel')
                }}</span>
              </v-flex>
              <v-flex
                xs12
                sm12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('fbPixel') }"
              >
                <label
                  >{{ $t('Tiktok Pixel') }} ({{
                    $t('Beta a temporary trial of the system')
                  }})</label
                >
                <div style="display: flex;">
                  <textarea
                    type="text"
                    name="tiktokPixel"
                    placeholder="Tiktok Pixel code"
                    v-validate="''"
                    :data-vv-as="$t('Tiktok Pixel')"
                    :readonly="!getPackageConfig().salepageAnalytics"
                    class="form-control"
                    ref="shareLink"
                    style="resize: vertical; min-height: 90px;"
                    v-model="tiktokPixel"
                  ></textarea>
                </div>
                <span class="text-error" v-if="errors.has('tiktokPixel')">{{
                  errors.first('tiktokPixel')
                }}</span>
              </v-flex>
              <v-flex
                xs12
                sm12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('fbPixel') }"
              >
                <label
                  >{{ $t('Google Analytics') }} ({{
                    $t('Beta a temporary trial of the system')
                  }})</label
                >
                <div style="display: flex;">
                  <input
                    :disabled="!getPackageConfig().salepageAnalytics"
                    placeholder="Tracking ID"
                    :data-vv-as="$t('Tiktok Pixel')"
                    v-model="googleAnalytics"
                    v-validate="''"
                    name="googleAnalytics"
                    class="form-control"
                    type="text"
                  />
                </div>
                <span class="text-error" v-if="errors.has('googleAnalytics')">{{
                  errors.first('googleAnalytics')
                }}</span>
              </v-flex>
              <v-flex
                xs12
                sm12
                class="form-control pa-1"
                :class="{ 'has-error': errors.has('fbPixel') }"
              >
                <label
                  >{{ $t('Google tag manager') }} ({{
                    $t('Beta a temporary trial of the system')
                  }})</label
                >
                <div style="display: flex;">
                  <input
                    :disabled="!getPackageConfig().salepageAnalytics"
                    placeholder="Container ID"
                    :data-vv-as="$t('Google tag manager')"
                    v-model="googleTag"
                    v-validate="''"
                    name="googleTag"
                    class="form-control"
                    type="text"
                  />
                </div>
                <span class="text-error" v-if="errors.has('googleTag')">{{
                  errors.first('googleTag')
                }}</span>
              </v-flex>
            </v-layout>
          </div>
        </transition>

        <div class="text-xs-center mt-5">
          <v-btn color="grey" outline @click="onCancel()" :disabled="!isEdit">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-container>
      <v-divider class="my-4" />
      <v-container>
        <h2 class="mb-2">{{ $t('Choose Template') }}</h2>
        <v-layout style="overflow: auto;">
          <v-flex class="pa-1" shrink xs12 sm4 v-for="(item, i) in templateAll" :key="i">
            <v-hover>
              <v-card
                :style="templateSelect.template_id === item.template_id ? 'background:#ed1e79' : ''"
                @click="selectTemplate(item)"
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                style="cursor:pointer"
              >
                <v-card-title primary-title>
                  <div>
                    <h2
                      class="mb-0"
                      :style="
                        templateSelect.template_id === item.template_id ? 'color:#FFFFFF' : ''
                      "
                    >
                      {{ $t('Template') }} {{ i + 1 }}
                    </h2>
                  </div>
                </v-card-title>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
        <v-flex class="pa-1" v-if="templateSelect.template_id && isEdit">
          <v-hover>
            <v-card
              :style="templateSelect.template_id === templateid ? 'background:#ed1e79' : ''"
              @click="onCancel()"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              style="cursor:pointer"
            >
              <v-card-title primary-title>
                <div>
                  <h2
                    class="mb-0"
                    :style="templateSelect.template_id === templateid ? 'color:#FFFFFF' : ''"
                  >
                    {{ $t('Your Salepage') }}
                  </h2>
                </div>
              </v-card-title>
            </v-card>
          </v-hover>
        </v-flex>
        <v-layout class="mt-5">
          <v-flex xs12 sm6>
            <form-sale-page
              v-if="templateSelect.template_id"
              :categories="categories"
              v-model="templateSelect"
              @resetShowPreview="resetShowPreview"
            ></form-sale-page>
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-center" v-if="salepageLg">
            <preview-sale-page
              style="position: sticky;
    top: 80px;"
              v-if="templateSelect.template_id"
              :categories="categories"
              v-model="templateSelect"
              :showPreview="showPreview"
              :shopName="shopName"
            ></preview-sale-page>
          </v-flex>
        </v-layout>
        <div class="text-xs-center" v-if="!salepageLg">
          <v-dialog v-model="dialog" width="460">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
                <i class="fas fa-mobile-alt mr-2" style="font-size: 20px;"></i>Preview
              </v-btn>
            </template>

            <!-- <v-card class="pa-3"> -->
            <preview-sale-page
              style="position: sticky;top: 80px;"
              v-if="templateSelect.template_id"
              :categories="categories"
              v-model="templateSelect"
              :showPreview="showPreview"
              :shopName="shopName"
            ></preview-sale-page>
            <!-- </v-card> -->
          </v-dialog>
        </div>
        <div class="text-xs-center mt-5" v-if="templateSelect.template_id">
          <v-btn color="grey" outline @click="onCancel()" :disabled="!isEdit">
            {{ $t('cancel') }}
          </v-btn>
          <v-btn color="primary" depressed @click="submit">
            {{ $t('Save') }}
          </v-btn>
        </div>
      </v-container>
    </form>
  </div>
</template>

<script>
import FormSalePage from '@/components/salePage/FormSalePage'
import PreviewSalePage from '@/components/salePage/PreviewSalePage'
import api from '@/api'
import { mapGetters } from 'vuex'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  components: { FormSalePage, PreviewSalePage, ToggleButton },
  data: function() {
    return {
      salepageLg: true,
      dialog: false,
      showCopy: false,
      templateid: null,
      templateSelectBackup: null,
      isEdit: null,
      shopName: null,
      fbPixel: '',
      fbPixelbk: '',
      tiktokPixel: '',
      tiktokPixelbk: '',
      googleAnalytics: '',
      googleAnalyticsbk: '',
      googleTag: '',
      googleTagbk: '',
      showPreview: true,
      showCopy: false,
      templateSelect: [{ template_id: null, template: [] }],
      categories: [],
      salePageIsActive: false,
      templateAll: [],
      setload: false,
      showAdvanced: false
    }
  },
  created() {
    this.getCategories().then(() => {
      this.templateAll = [
        {
          color: null,
          checkoutBtn: 'fixed',
          template_id: 1,
          template: [
            {
              type: 'slideshow',
              images: [null],
              color: {
                hex: '#F17B9B'
              }
            },
            {
              type: 'productslect',
              option: 'custom',
              productSelect: [],
              titleName: 'สินค้าแนะนำ',
              color: {
                hex: '#FFB7E5'
              }
            },
            {
              type: 'productlist',
              option: 'tab',
              borderColor: {
                hex: '#000000'
              },
              images: this.setObjectCategories(),
              color: {
                hex: '#FFD2D9'
              }
            }
          ]
        },
        {
          color: null,
          checkoutBtn: 'fixed',
          template_id: 2,
          template: [
            {
              type: 'photo',
              image: [null],
              option: '1to1',
              color: {
                hex: '#19B092'
              }
            },
            {
              type: 'productlist',
              option: 'image',
              borderColor: {
                hex: '#000000'
              },
              images: this.setObjectCategories(),
              color: {
                hex: '#AEDB94'
              }
            }
          ]
        },
        {
          color: null,
          checkoutBtn: 'fixed',
          template_id: 3,
          template: [
            {
              type: 'photo',
              image: [null],
              option: '1to1',
              color: {
                hex: '#F1C40F'
              }
            },
            {
              type: 'productlist',
              option: 'btn',
              borderColor: {
                hex: '#000000'
              },
              images: this.setObjectCategories(),
              color: {
                hex: '#FFFAC5'
              }
            }
          ]
        },
        {
          color: null,
          checkoutBtn: 'fixed',
          template_id: 4,
          template: [
            {
              type: 'slideshow',
              images: [null],
              color: {
                hex: '#FFFFFF'
              }
            },
            {
              type: 'photo',
              image: [null],
              option: '2to1',
              color: {
                hex: '#FFFFFF'
              }
            },
            {
              type: 'productlist',
              option: 'image',
              borderColor: {
                hex: '#000000'
              },
              images: this.setObjectCategories(),
              color: {
                hex: '#FA9D00'
              }
            }
          ]
        }
      ]
    })
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    this.salepageLg = this.$refs.salepage.offsetWidth >= 600
    this.$store.dispatch('loadProducts')
    this.getSalePage()
  },
  methods: {
    onShowAdvance: function() {
      this.showAdvanced = !this.showAdvanced
    },
    onCopy() {
      let vm = this

      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 3000)
    },
    onCopyError() {},
    setObjectCategories() {
      this.setload = true
      var object = [{ '0': null }, { '1': null }]
      this.categories.map(item => {
        object.push({ [item.id]: null })
      })
      this.setload = false
      return object
    },
    toggleActiveSalePage: function() {
      this.salePageIsActive = !this.salePageIsActive
      this.submitPostAndPutSalePage(true)
    },
    onCancel() {
      this.$store.dispatch('loading')
      this.fbPixel = this.fbPixelbk
      this.tiktokPixel = this.tiktokPixelbk
      this.googleAnalytics = this.googleAnalyticsbk
      this.googleTag = this.googleTagbk
      this.templateSelect = JSON.parse(this.templateSelectBackup)
      setTimeout(() => {
        this.$store.dispatch('loading')
      }, 1000)
    },
    async getSalePage() {
      if (this.$store.getters.getPackage == 'premium') {
        this.$store.dispatch('loading')
      }
      try {
        var { result } = await api.getSalePage({
          params: {
            pageid: this.selectedBot.pageid
          }
        })
        if (result) {
          this.isEdit = true
          this.templateSelect = result.content_json
          this.templateSelectBackup = JSON.stringify(result.content_json)
          this.salePageIsActive = result.is_active
          this.shopName = result.shop_name
          this.fbPixelbk = result.fb_pixel
          this.fbPixel = result.fb_pixel
          this.tiktokPixelbk = result.tiktok_pixel
          this.tiktokPixel = result.tiktok_pixel
          this.googleAnalyticsbk = result.google_analytics
          this.googleAnalytics = result.google_analytics
          this.googleTagbk = result.google_tag
          this.googleTag = result.google_tag
          if (result.content_json) {
            this.templateid = result.content_json.template_id
          }
          if (this.$store.getters.getPackage == 'premium') {
            this.$store.dispatch('loading')
          }
        }
      } catch (error) {
        if (this.$store.getters.getPackage == 'premium') {
          this.$store.dispatch('loading')
        }
        this.isEdit = false
      }
    },

    getCategories: function() {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.selectedBot.pageid
        }
        api.getCategories(data, function(error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response && response.categorylist && response.categorylist.length !== 0) {
            vm.categories = response.categorylist.filter(el => !el.is_hidden)
          }
          resolve()
        })
      })
    },

    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      } else {
        this.submitPostAndPutSalePage(false)
      }
    },

    submitPostAndPutSalePage(toggle) {
      if (!this.isEdit) {
        this.postAndPutSalePage('post').then(() => {
          this.isEdit = true
          this.$swal({
            title: 'สำเร็จ',
            type: 'success',
            text: `ข้อมูลของท่านทำการบันทึกเรียบร้อยแล้ว`,
            confirmButtonText: this.$t('Confirm')
          })
        })
      } else {
        this.postAndPutSalePage('put').then(() => {
          if (toggle) {
            if (this.salePageIsActive) {
              this.$swal({
                title: 'สำเร็จ',
                type: 'success',
                text: `Salepage ของคุณเปิดใช้งานแล้ว`,
                confirmButtonText: this.$t('Confirm')
              })
            } else {
              this.$swal({
                title: 'สำเร็จ',
                type: 'success',
                text: `Salepage ของคุณยังไม่เปิดใช้งาน`,
                confirmButtonText: this.$t('Confirm')
              })
            }
          } else {
            this.$swal({
              title: 'สำเร็จ',
              type: 'success',
              text: `ข้อมูลของท่านทำการบันทึกเรียบร้อยแล้ว`,
              confirmButtonText: this.$t('Confirm')
            })
          }
        })
      }
    },

    async postAndPutSalePage(type) {
      this.$store.dispatch('loading')
      this.templateSelect.template_id = Date.now()
      let vm = this
      let body = {
        is_active: this.salePageIsActive,
        shop_name: this.shopName,
        shop_link: `https://shopv2.zwiz.app/salepage/${this.selectedBot.pageid}`,
        content_json: JSON.stringify(this.templateSelect)
      }

      if (this.check_privilege('salepage_analytic') && this.getPackageType().includes('advanced')) {
        body = {
          ...body,
          fb_pixel: this.fbPixel,
          tiktok_pixel: this.tiktokPixel,
          google_analytics: this.googleAnalytics,
          google_tag: this.googleTag
        }
      } else {
        body = {
          ...body,
          fb_pixel: '',
          tiktok_pixel: '',
          google_analytics: '',
          google_tag: ''
        }
      }
      let data = {
        params: {
          pageid: this.selectedBot.pageid
        },
        body: body
      }
      try {
        if (type === 'post') {
          var { result } = await api.postSalePage(data)
        } else {
          var { result } = await api.putSalePage(data)
        }
        vm.fbPixelbk = result.fb_pixel
        vm.tiktokPixelbk = result.tiktok_pixel
        vm.googleAnalyticsbk = result.google_analytics
        vm.googleTagbk = result.google_tag
        vm.templateSelect = result.content_json
        vm.templateSelect.template_id = Date.now()
        vm.templateSelectBackup = JSON.stringify(result.content_json)
        vm.templateid = result.content_json.template_id
        vm.$store.dispatch('loading')
      } catch (error) {
        vm.$store.dispatch('loading')
        vm.$swal.fire({
          type: 'error',
          text: 'มีบางอย่างผิดพลาด ไม่สามารถทำการบันทึกได้'
        })
      }
    },
    resetShowPreview() {
      this.showPreview = false
      this.$nextTick(() => {
        this.showPreview = true
      })
    },
    selectTemplate(template) {
      this.$store.dispatch('loading')
      this.templateSelect = template
      setTimeout(() => {
        this.$store.dispatch('loading')
      }, 500)
    },
    onCopy: function() {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function() {}
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/template/ecommerce/SalePage.vue